import React, { useEffect } from 'react';

import * as copy from '../constants/copy';
import * as styles from '../styles';

interface NoSearchResultsGuardProps {
  children: React.ReactNode;
  noSearchResultsReturned: boolean;
  onMessageVisable: VoidFunction;
  searchTerm: string;
}

export const NoSearchResultsGuard = ({
  noSearchResultsReturned,
  onMessageVisable,
  searchTerm,
  children,
}: NoSearchResultsGuardProps) => {
  useEffect(() => {
    if (noSearchResultsReturned) {
      onMessageVisable();
    }
  }, [noSearchResultsReturned, onMessageVisable]);

  return noSearchResultsReturned ? (
    <div css={styles.noSearchResultsWrapper}>
      <h1 css={styles.heading}>
        <span css={styles.headingText}>{copy.HEADING}</span>
        <span css={styles.headingTerm}>&quot;{searchTerm}&quot;</span>
      </h1>
      <p css={styles.info}>{copy.TRY_AGAIN_INFO}</p>
    </div>
  ) : (
    <>{children}</>
  );
};
